/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
// icon
import { PickBtnIco } from '@shared/Icon/PickIcon'
import { Title, TitleWrap } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'
import ComponentBetSlip from '@views/Popup/ComponentBetSlip'
import Chat from '@views/Popup/Chat'
import PickTab from './PickTab'
import { bettingHistoryStore } from '@store/index'
import { FROM_VIEW_TYPE } from '@v2/constants/common'
import PopupUtils from '@utils/popup-utils'
import { loadOrReload } from '@utils/utils'

// css
// import styled from '@themes/theme'

const ButtonStyle = css`
    z-index: 2;
    position: fixed;
    align-items: center;
    right: 14px;
    bottom: 85px;
    width: 45px;
    height: 45px;

    svg {
        top: 2px;
        left: 2px;
        display: block;
        margin: 0 auto;
        width: 28px;
    }
`

const Pick: React.FC = () => {
  const { pickStore, authStore, chattingStore, componentStore } = useRootStore()
  const { isChatEnabled } = chattingStore

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      loadOrReload('/')
    } else {
      componentStore.setExtraClubId(null)
    }
  })
  useOnUnmount(() => {
    pickStore.cleanup()
  })

  const onClickJumpToBettingHistoryHandler = () => {
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.USER_PICK)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: true, fromViewType: FROM_VIEW_TYPE.USER_PICK })
    if (isMobile) {
      loadOrReload('/betting-history')
    } else {
      PopupUtils.showBettingHistoryPopup()
    }
  }

  return (
    <Fragment>
      <TitleWrap className="title-wrap modal">
        <Title className="title">픽거래소</Title>
      </TitleWrap>

      <PickTab />

      <Button onClick={onClickJumpToBettingHistoryHandler} primary float circle css={ButtonStyle}
              className="floating-btn">
        <PickBtnIco />
      </Button>
      {!isMobile && <ComponentBetSlip />}
      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="Pick:Chat" />}
    </Fragment>
  )
}

export default observer(Pick)
